import { render, staticRenderFns } from "./DocumentToggle.vue?vue&type=template&id=1d09e840&scoped=true"
import script from "./DocumentToggle.vue?vue&type=script&lang=js"
export * from "./DocumentToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d09e840",
  null
  
)

export default component.exports